// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: world-space numbers for the 3D viewer.
// Source units, Z up, so round-file coordinates are used as they are. No three.js here.
// In the round file viewX is yaw and viewY is pitch (positive pitch looks down).
const RADAR_SIZE = 1024;
export const PLAYER_RADIUS = 16;
export const STANDING_HEIGHT = 72;
const CROUCHED_HEIGHT = 54;
const EYE_BELOW_TOP = 8;
const RAD = Math.PI / 180;

// The same world rectangle useRenderer.getConvertedCords maps onto the radar.
export function radarFloorBounds({ x_0: x0, y_0: y0, scale }) {
  return {
    minX: x0,
    maxX: x0 + RADAR_SIZE * scale,
    minY: y0 - RADAR_SIZE * scale,
    maxY: y0,
  };
}

export const isDead = (player) => player.isAlive === false || player.hp === 0;

// Rounds parsed before rsparse wrote duck_amount only carry the isDucking boolean. An unset proto
// field reads as its default from the prototype, so only a value the round really has counts.
export const duckAmount = (player) => (
  (Object.hasOwn(player, 'duckAmount') ? player.duckAmount : null) ?? (player.isDucking ? 1 : 0)
);

export function playerHeight(player) {
  return STANDING_HEIGHT - (STANDING_HEIGHT - CROUCHED_HEIGHT) * duckAmount(player);
}

export function playerCapsuleCenter(player) {
  return { x: player.x, y: player.y, z: (player.z || 0) + playerHeight(player) / 2 };
}

export function eyePosition(player) {
  return { x: player.x, y: player.y, z: (player.z || 0) + playerHeight(player) - EYE_BELOW_TOP };
}

export function aimDirection(player) {
  const yaw = (player.viewX || 0) * RAD;
  const pitch = (player.viewY || 0) * RAD;
  return {
    x: Math.cos(pitch) * Math.cos(yaw),
    y: Math.cos(pitch) * Math.sin(yaw),
    z: -Math.sin(pitch),
  };
}

export const framePlayers = (frame) => [
  ...(frame?.ct?.players ?? []),
  ...(frame?.t?.players ?? []),
];

// Lowest z of any alive player in the round, or null when every alive player sits at
// exactly z 0 (legacy rounds parsed without height).
export function roundFloorZ(frames) {
  let floor = Infinity;
  let hasHeight = false;
  frames.forEach((frame) => framePlayers(frame).forEach((player) => {
    if (isDead(player)) return;
    const z = player.z || 0;
    if (z !== 0) hasHeight = true;
    if (z < floor) floor = z;
  }));
  return hasHeight ? floor : null;
}

// Between frame i and i+1 during playback, as the 2D renderer does. Yaw takes the short way round.
export function lerpPlayer(from, to, t) {
  if (!to || !t) return from;
  const mix = (a, b) => (a || 0) + ((b || 0) - (a || 0)) * t;
  const yawDelta = (((((to.viewX || 0) - (from.viewX || 0)) % 360) + 540) % 360) - 180;
  return {
    ...from,
    x: mix(from.x, to.x),
    y: mix(from.y, to.y),
    z: mix(from.z, to.z),
    viewX: (from.viewX || 0) + yawDelta * t,
    viewY: mix(from.viewY, to.viewY),
    duckAmount: mix(duckAmount(from), duckAmount(to)),
  };
}
